import Alert from '@mui/material/Alert';
import Grow from '@mui/material/Grow';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

interface ScopesAlertProps {
  affectedColumns?: string[];
  apiKey: 'cloudIdentity' | 'driveLabels' | 'driveLabelsWrite';
  isReportsOrBulkOps?: boolean;
  additionalText?: string;
}

const apiKeyNiceNames: Record<ScopesAlertProps['apiKey'], string> = {
  cloudIdentity: 'Cloud Identity',
  driveLabels: 'Drive Labels',
  driveLabelsWrite: 'Drive Labels (manage labels)',
};

export default function ScopesAlert({
  affectedColumns = [],
  apiKey,
  isReportsOrBulkOps = false,
  additionalText,
}: ScopesAlertProps) {
  return (
    <Grow in={true}>
      <Alert
        severity="warning"
        sx={{
          '& .MuiAlert-icon': {
            color: 'warning.main',
          },
        }}
      >
        You have not{' '}
        <Link
          href="https://gpanel.io/knowledge/getting-started/enabling-new-scopes"
          target="_blank"
          rel="noopener noreferrer"
        >
          granted data access
        </Link>{' '}
        to the {apiKeyNiceNames[apiKey]} API for gPanel.
        {additionalText && ` ${additionalText}`}
        {isReportsOrBulkOps
          ? 'The following columns will not be available:'
          : ''}
        {isReportsOrBulkOps && (
          <List dense>
            {affectedColumns.map((column) => (
              <ListItem key={column}>
                <ListItemText primary={`• ${column}`} />
              </ListItem>
            ))}
          </List>
        )}
      </Alert>
    </Grow>
  );
}
